import zIndex from '@material-ui/core/styles/zIndex'

const styles = theme => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
  },
  headerContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '24px',
  },
  section: {
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
  },
  popover: {
    zIndex: '1351',
  },
  colorPickerContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
  },
  pickerBg: {
    position: 'relative',
    boxSizing: 'border-box',
    display: 'flex',
    width: 32,
    height: 32,
    background: '#fff',
    borderRadius: '6px',
    alignItems: 'center',
    justifyContent: 'center',
    border: '1px solid #E5E7EB',
    cursor: 'pointer',
  },
  pickerSpan: {
    width: 20,
    height: 20,
    borderRadius: '4px',
  },
  uploadContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
  },
  uploadBox: {
    width: '284px',
    height: '160px',
    background: '#F9FAFB',
    border: '1px dashed #E5E7EB',
    borderRadius: '12px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    '&:hover': {
      background: '#F3F4F6',
    },
  },
  plusIcon: {
    fontSize: '24px',
    color: '#9CA3AF',
  },
  imagePreview: {
    display: 'flex',
    flexDirection: 'row',
    gap: '8px',
    alignItems: 'center',
  },
  faviconView: {
    position: 'relative',
    width: '64px',
    height: '64px',
    display: 'flex',
    alignItems: 'center',
    borderRadius: '8px',
  },
  iconButton: {
    position: 'absolute',
    top: 8,
    right: 8,
  },
  logoView: {
    position: 'relative',
    width: '100px',
    height: '100px',
    objectFit: 'cover',
    borderRadius: '12px',
  },
  changeButton: {
    background: 'none',
    border: 'none',
    color: '#4F46E5',
    padding: 0,
    cursor: 'pointer',
    fontSize: '14px',
    fontFamily: 'Inter',
    '&:hover': {
      textDecoration: 'underline',
    },
  },
  label: {
    fontSize: '14px',
    fontWeight: 500,
    color: '#111827',
    marginBottom: '4px',
    fontFamily: 'Inter',
  },
  helperText: {
    fontSize: '12px',
    color: '#6B7280',
    marginTop: '4px',
    fontFamily: 'Inter',
  },
  bottomButton: {
    marginTop: '24px',
  },
  scriptSection: {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
  },
  logoSection: {
    display: 'flex',
    flexDirection: 'column',
  },
  picker: {
    position: 'absolute',
    marginRight: -300,
    marginTop: 200,
    zIndex: 99,
  },
  uploadBoxLogo: {
    minWidth: '100px',
    height: '100px',
    background: '#F9FAFB',
    border: '1px dashed #E5E7EB',
    borderRadius: '12px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    width: '100px',
    '&:hover': {
      background: '#F3F4F6',
    },
  },
  sectionLogo: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
  },
  uploadBoxLogoContainer: {
    display: 'flex',
    flexDirection: 'row',
    gap: '16px',
    alignItems: 'center',
  },
  uploadBoxContainer: {
    display: 'flex',
    flexDirection: 'row',
    gap: '16px',
    alignItems: 'center',
  },
  uploadBoxFavicon: {
    minWidth: '64px',
    height: '64px',
    background: '#F9FAFB',
    border: '1px dashed #E5E7EB',
    borderRadius: '12px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    '&:hover': {
      background: '#F3F4F6',
    },
  },
  thumbnailView: {
    width: '284px',
    height: '160px',
    borderRadius: '12px',
    position: 'relative',
    display: 'flex',
  },
  header: {
    padding: '8px 0px',
  },
})

export default styles
